"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoDB = exports.MongoDBExit = void 0;
var MongoDBExit;
(function (MongoDBExit) {
    MongoDBExit[MongoDBExit["SuccessfulExit"] = 0] = "SuccessfulExit";
    MongoDBExit[MongoDBExit["OptionsError"] = 2] = "OptionsError";
    MongoDBExit[MongoDBExit["HostnameMismatch"] = 3] = "HostnameMismatch";
    MongoDBExit[MongoDBExit["VersionMismatch"] = 4] = "VersionMismatch";
    MongoDBExit[MongoDBExit["InstallationIssue"] = 5] = "InstallationIssue";
    MongoDBExit[MongoDBExit["WindowsShutdownEvent"] = 12] = "WindowsShutdownEvent";
    MongoDBExit[MongoDBExit["SystemExitUncleanShutdown"] = 14] = "SystemExitUncleanShutdown";
    MongoDBExit[MongoDBExit["WindowsWsaStartupFailedNtServiceError"] = 20] = "WindowsWsaStartupFailedNtServiceError";
    MongoDBExit[MongoDBExit["ListenError"] = 48] = "ListenError";
    MongoDBExit[MongoDBExit["IncompatibleDataFiles"] = 62] = "IncompatibleDataFiles";
    MongoDBExit[MongoDBExit["UncaughtException"] = 100] = "UncaughtException";
})(MongoDBExit = exports.MongoDBExit || (exports.MongoDBExit = {}));
var MongoDB;
(function (MongoDB) {
    MongoDB[MongoDB["Ok"] = 0] = "Ok";
    MongoDB[MongoDB["InternalError"] = 1] = "InternalError";
    MongoDB[MongoDB["BadValue"] = 2] = "BadValue";
    MongoDB[MongoDB["OBSOLETE_DuplicateKey"] = 3] = "OBSOLETE_DuplicateKey";
    MongoDB[MongoDB["NoSuchKey"] = 4] = "NoSuchKey";
    MongoDB[MongoDB["GraphContainsCycle"] = 5] = "GraphContainsCycle";
    MongoDB[MongoDB["HostUnreachable"] = 6] = "HostUnreachable";
    MongoDB[MongoDB["HostNotFound"] = 7] = "HostNotFound";
    MongoDB[MongoDB["UnknownError"] = 8] = "UnknownError";
    MongoDB[MongoDB["FailedToParse"] = 9] = "FailedToParse";
    MongoDB[MongoDB["CannotMutateObject"] = 10] = "CannotMutateObject";
    MongoDB[MongoDB["UserNotFound"] = 11] = "UserNotFound";
    MongoDB[MongoDB["UnsupportedFormat"] = 12] = "UnsupportedFormat";
    MongoDB[MongoDB["Unauthorized"] = 13] = "Unauthorized";
    MongoDB[MongoDB["TypeMismatch"] = 14] = "TypeMismatch";
    MongoDB[MongoDB["Overflow"] = 15] = "Overflow";
    MongoDB[MongoDB["InvalidLength"] = 16] = "InvalidLength";
    MongoDB[MongoDB["ProtocolError"] = 17] = "ProtocolError";
    MongoDB[MongoDB["AuthenticationFailed"] = 18] = "AuthenticationFailed";
    MongoDB[MongoDB["CannotReuseObject"] = 19] = "CannotReuseObject";
    MongoDB[MongoDB["IllegalOperation"] = 20] = "IllegalOperation";
    MongoDB[MongoDB["EmptyArrayOperation"] = 21] = "EmptyArrayOperation";
    MongoDB[MongoDB["InvalidBSON"] = 22] = "InvalidBSON";
    MongoDB[MongoDB["AlreadyInitialized"] = 23] = "AlreadyInitialized";
    MongoDB[MongoDB["LockTimeout"] = 24] = "LockTimeout";
    MongoDB[MongoDB["RemoteValidationError"] = 25] = "RemoteValidationError";
    MongoDB[MongoDB["NamespaceNotFound"] = 26] = "NamespaceNotFound";
    MongoDB[MongoDB["IndexNotFound"] = 27] = "IndexNotFound";
    MongoDB[MongoDB["PathNotViable"] = 28] = "PathNotViable";
    MongoDB[MongoDB["NonExistentPath"] = 29] = "NonExistentPath";
    MongoDB[MongoDB["InvalidPath"] = 30] = "InvalidPath";
    MongoDB[MongoDB["RoleNotFound"] = 31] = "RoleNotFound";
    MongoDB[MongoDB["RolesNotRelated"] = 32] = "RolesNotRelated";
    MongoDB[MongoDB["PrivilegeNotFound"] = 33] = "PrivilegeNotFound";
    MongoDB[MongoDB["CannotBackfillArray"] = 34] = "CannotBackfillArray";
    MongoDB[MongoDB["UserModificationFailed"] = 35] = "UserModificationFailed";
    MongoDB[MongoDB["RemoteChangeDetected"] = 36] = "RemoteChangeDetected";
    MongoDB[MongoDB["FileRenameFailed"] = 37] = "FileRenameFailed";
    MongoDB[MongoDB["FileNotOpen"] = 38] = "FileNotOpen";
    MongoDB[MongoDB["FileStreamFailed"] = 39] = "FileStreamFailed";
    MongoDB[MongoDB["ConflictingUpdateOperators"] = 40] = "ConflictingUpdateOperators";
    MongoDB[MongoDB["FileAlreadyOpen"] = 41] = "FileAlreadyOpen";
    MongoDB[MongoDB["LogWriteFailed"] = 42] = "LogWriteFailed";
    MongoDB[MongoDB["CursorNotFound"] = 43] = "CursorNotFound";
    MongoDB[MongoDB["UserDataInconsistent"] = 45] = "UserDataInconsistent";
    MongoDB[MongoDB["LockBusy"] = 46] = "LockBusy";
    MongoDB[MongoDB["NoMatchingDocument"] = 47] = "NoMatchingDocument";
    MongoDB[MongoDB["NamespaceExists"] = 48] = "NamespaceExists";
    MongoDB[MongoDB["InvalidRoleModification"] = 49] = "InvalidRoleModification";
    MongoDB[MongoDB["MaxTimeMSExpired"] = 50] = "MaxTimeMSExpired";
    MongoDB[MongoDB["ManualInterventionRequired"] = 51] = "ManualInterventionRequired";
    MongoDB[MongoDB["DollarPrefixedFieldName"] = 52] = "DollarPrefixedFieldName";
    MongoDB[MongoDB["InvalidIdField"] = 53] = "InvalidIdField";
    MongoDB[MongoDB["NotSingleValueField"] = 54] = "NotSingleValueField";
    MongoDB[MongoDB["InvalidDBRef"] = 55] = "InvalidDBRef";
    MongoDB[MongoDB["EmptyFieldName"] = 56] = "EmptyFieldName";
    MongoDB[MongoDB["DottedFieldName"] = 57] = "DottedFieldName";
    MongoDB[MongoDB["RoleModificationFailed"] = 58] = "RoleModificationFailed";
    MongoDB[MongoDB["CommandNotFound"] = 59] = "CommandNotFound";
    MongoDB[MongoDB["OBSOLETE_DatabaseNotFound"] = 60] = "OBSOLETE_DatabaseNotFound";
    MongoDB[MongoDB["ShardKeyNotFound"] = 61] = "ShardKeyNotFound";
    MongoDB[MongoDB["OplogOperationUnsupported"] = 62] = "OplogOperationUnsupported";
    MongoDB[MongoDB["StaleShardVersion"] = 63] = "StaleShardVersion";
    MongoDB[MongoDB["WriteConcernFailed"] = 64] = "WriteConcernFailed";
    MongoDB[MongoDB["MultipleErrorsOccurred"] = 65] = "MultipleErrorsOccurred";
    MongoDB[MongoDB["ImmutableField"] = 66] = "ImmutableField";
    MongoDB[MongoDB["CannotCreateIndex"] = 67] = "CannotCreateIndex";
    MongoDB[MongoDB["IndexAlreadyExists"] = 68] = "IndexAlreadyExists";
    MongoDB[MongoDB["AuthSchemaIncompatible"] = 69] = "AuthSchemaIncompatible";
    MongoDB[MongoDB["ShardNotFound"] = 70] = "ShardNotFound";
    MongoDB[MongoDB["ReplicaSetNotFound"] = 71] = "ReplicaSetNotFound";
    MongoDB[MongoDB["InvalidOptions"] = 72] = "InvalidOptions";
    MongoDB[MongoDB["InvalidNamespace"] = 73] = "InvalidNamespace";
    MongoDB[MongoDB["NodeNotFound"] = 74] = "NodeNotFound";
    MongoDB[MongoDB["WriteConcernLegacyOK"] = 75] = "WriteConcernLegacyOK";
    MongoDB[MongoDB["NoReplicationEnabled"] = 76] = "NoReplicationEnabled";
    MongoDB[MongoDB["OperationIncomplete"] = 77] = "OperationIncomplete";
    MongoDB[MongoDB["CommandResultSchemaViolation"] = 78] = "CommandResultSchemaViolation";
    MongoDB[MongoDB["UnknownReplWriteConcern"] = 79] = "UnknownReplWriteConcern";
    MongoDB[MongoDB["RoleDataInconsistent"] = 80] = "RoleDataInconsistent";
    MongoDB[MongoDB["NoMatchParseContext"] = 81] = "NoMatchParseContext";
    MongoDB[MongoDB["NoProgressMade"] = 82] = "NoProgressMade";
    MongoDB[MongoDB["RemoteResultsUnavailable"] = 83] = "RemoteResultsUnavailable";
    MongoDB[MongoDB["DuplicateKeyValue"] = 84] = "DuplicateKeyValue";
    MongoDB[MongoDB["IndexOptionsConflict"] = 85] = "IndexOptionsConflict";
    MongoDB[MongoDB["IndexKeySpecsConflict"] = 86] = "IndexKeySpecsConflict";
    MongoDB[MongoDB["CannotSplit"] = 87] = "CannotSplit";
    MongoDB[MongoDB["SplitFailed_OBSOLETE"] = 88] = "SplitFailed_OBSOLETE";
    MongoDB[MongoDB["NetworkTimeout"] = 89] = "NetworkTimeout";
    MongoDB[MongoDB["CallbackCanceled"] = 90] = "CallbackCanceled";
    MongoDB[MongoDB["ShutdownInProgress"] = 91] = "ShutdownInProgress";
    MongoDB[MongoDB["SecondaryAheadOfPrimary"] = 92] = "SecondaryAheadOfPrimary";
    MongoDB[MongoDB["InvalidReplicaSetConfig"] = 93] = "InvalidReplicaSetConfig";
    MongoDB[MongoDB["NotYetInitialized"] = 94] = "NotYetInitialized";
    MongoDB[MongoDB["NotSecondary"] = 95] = "NotSecondary";
    MongoDB[MongoDB["OperationFailed"] = 96] = "OperationFailed";
    MongoDB[MongoDB["NoProjectionFound"] = 97] = "NoProjectionFound";
    MongoDB[MongoDB["DBPathInUse"] = 98] = "DBPathInUse";
    MongoDB[MongoDB["UnsatisfiableWriteConcern"] = 100] = "UnsatisfiableWriteConcern";
    MongoDB[MongoDB["OutdatedClient"] = 101] = "OutdatedClient";
    MongoDB[MongoDB["IncompatibleAuditMetadata"] = 102] = "IncompatibleAuditMetadata";
    MongoDB[MongoDB["NewReplicaSetConfigurationIncompatible"] = 103] = "NewReplicaSetConfigurationIncompatible";
    MongoDB[MongoDB["NodeNotElectable"] = 104] = "NodeNotElectable";
    MongoDB[MongoDB["IncompatibleShardingMetadata"] = 105] = "IncompatibleShardingMetadata";
    MongoDB[MongoDB["DistributedClockSkewed"] = 106] = "DistributedClockSkewed";
    MongoDB[MongoDB["LockFailed"] = 107] = "LockFailed";
    MongoDB[MongoDB["InconsistentReplicaSetNames"] = 108] = "InconsistentReplicaSetNames";
    MongoDB[MongoDB["ConfigurationInProgress"] = 109] = "ConfigurationInProgress";
    MongoDB[MongoDB["CannotInitializeNodeWithData"] = 110] = "CannotInitializeNodeWithData";
    MongoDB[MongoDB["NotExactValueField"] = 111] = "NotExactValueField";
    MongoDB[MongoDB["WriteConflict"] = 112] = "WriteConflict";
    MongoDB[MongoDB["InitialSyncFailure"] = 113] = "InitialSyncFailure";
    MongoDB[MongoDB["InitialSyncOplogSourceMissing"] = 114] = "InitialSyncOplogSourceMissing";
    MongoDB[MongoDB["CommandNotSupported"] = 115] = "CommandNotSupported";
    MongoDB[MongoDB["DocTooLargeForCapped"] = 116] = "DocTooLargeForCapped";
    MongoDB[MongoDB["ConflictingOperationInProgress"] = 117] = "ConflictingOperationInProgress";
    MongoDB[MongoDB["NamespaceNotSharded"] = 118] = "NamespaceNotSharded";
    MongoDB[MongoDB["InvalidSyncSource"] = 119] = "InvalidSyncSource";
    MongoDB[MongoDB["OplogStartMissing"] = 120] = "OplogStartMissing";
    MongoDB[MongoDB["DocumentValidationFailure"] = 121] = "DocumentValidationFailure";
    MongoDB[MongoDB["OBSOLETE_ReadAfterOptimeTimeout"] = 122] = "OBSOLETE_ReadAfterOptimeTimeout";
    MongoDB[MongoDB["NotAReplicaSet"] = 123] = "NotAReplicaSet";
    MongoDB[MongoDB["IncompatibleElectionProtocol"] = 124] = "IncompatibleElectionProtocol";
    MongoDB[MongoDB["CommandFailed"] = 125] = "CommandFailed";
    MongoDB[MongoDB["RPCProtocolNegotiationFailed"] = 126] = "RPCProtocolNegotiationFailed";
    MongoDB[MongoDB["UnrecoverableRollbackError"] = 127] = "UnrecoverableRollbackError";
    MongoDB[MongoDB["LockNotFound"] = 128] = "LockNotFound";
    MongoDB[MongoDB["LockStateChangeFailed"] = 129] = "LockStateChangeFailed";
    MongoDB[MongoDB["SymbolNotFound"] = 130] = "SymbolNotFound";
    MongoDB[MongoDB["OBSOLETE_ConfigServersInconsistent"] = 132] = "OBSOLETE_ConfigServersInconsistent";
    MongoDB[MongoDB["FailedToSatisfyReadPreference"] = 133] = "FailedToSatisfyReadPreference";
    MongoDB[MongoDB["ReadConcernMajorityNotAvailableYet"] = 134] = "ReadConcernMajorityNotAvailableYet";
    MongoDB[MongoDB["StaleTerm"] = 135] = "StaleTerm";
    MongoDB[MongoDB["CappedPositionLost"] = 136] = "CappedPositionLost";
    MongoDB[MongoDB["IncompatibleShardingConfigVersion"] = 137] = "IncompatibleShardingConfigVersion";
    MongoDB[MongoDB["RemoteOplogStale"] = 138] = "RemoteOplogStale";
    MongoDB[MongoDB["JSInterpreterFailure"] = 139] = "JSInterpreterFailure";
    MongoDB[MongoDB["InvalidSSLConfiguration"] = 140] = "InvalidSSLConfiguration";
    MongoDB[MongoDB["SSLHandshakeFailed"] = 141] = "SSLHandshakeFailed";
    MongoDB[MongoDB["JSUncatchableError"] = 142] = "JSUncatchableError";
    MongoDB[MongoDB["CursorInUse"] = 143] = "CursorInUse";
    MongoDB[MongoDB["IncompatibleCatalogManager"] = 144] = "IncompatibleCatalogManager";
    MongoDB[MongoDB["PooledConnectionsDropped"] = 145] = "PooledConnectionsDropped";
    MongoDB[MongoDB["ExceededMemoryLimit"] = 146] = "ExceededMemoryLimit";
    MongoDB[MongoDB["ZLibError"] = 147] = "ZLibError";
    MongoDB[MongoDB["ReadConcernMajorityNotEnabled"] = 148] = "ReadConcernMajorityNotEnabled";
    MongoDB[MongoDB["NoConfigMaster"] = 149] = "NoConfigMaster";
    MongoDB[MongoDB["StaleEpoch"] = 150] = "StaleEpoch";
    MongoDB[MongoDB["OperationCannotBeBatched"] = 151] = "OperationCannotBeBatched";
    MongoDB[MongoDB["OplogOutOfOrder"] = 152] = "OplogOutOfOrder";
    MongoDB[MongoDB["ChunkTooBig"] = 153] = "ChunkTooBig";
    MongoDB[MongoDB["InconsistentShardIdentity"] = 154] = "InconsistentShardIdentity";
    MongoDB[MongoDB["CannotApplyOplogWhilePrimary"] = 155] = "CannotApplyOplogWhilePrimary";
    MongoDB[MongoDB["OBSOLETE_NeedsDocumentMove"] = 156] = "OBSOLETE_NeedsDocumentMove";
    MongoDB[MongoDB["CanRepairToDowngrade"] = 157] = "CanRepairToDowngrade";
    MongoDB[MongoDB["MustUpgrade"] = 158] = "MustUpgrade";
    MongoDB[MongoDB["DurationOverflow"] = 159] = "DurationOverflow";
    MongoDB[MongoDB["MaxStalenessOutOfRange"] = 160] = "MaxStalenessOutOfRange";
    MongoDB[MongoDB["IncompatibleCollationVersion"] = 161] = "IncompatibleCollationVersion";
    MongoDB[MongoDB["CollectionIsEmpty"] = 162] = "CollectionIsEmpty";
    MongoDB[MongoDB["ZoneStillInUse"] = 163] = "ZoneStillInUse";
    MongoDB[MongoDB["InitialSyncActive"] = 164] = "InitialSyncActive";
    MongoDB[MongoDB["ViewDepthLimitExceeded"] = 165] = "ViewDepthLimitExceeded";
    MongoDB[MongoDB["CommandNotSupportedOnView"] = 166] = "CommandNotSupportedOnView";
    MongoDB[MongoDB["OptionNotSupportedOnView"] = 167] = "OptionNotSupportedOnView";
    MongoDB[MongoDB["InvalidPipelineOperator"] = 168] = "InvalidPipelineOperator";
    MongoDB[MongoDB["CommandOnShardedViewNotSupportedOnMongod"] = 169] = "CommandOnShardedViewNotSupportedOnMongod";
    MongoDB[MongoDB["TooManyMatchingDocuments"] = 170] = "TooManyMatchingDocuments";
    MongoDB[MongoDB["CannotIndexParallelArrays"] = 171] = "CannotIndexParallelArrays";
    MongoDB[MongoDB["TransportSessionClosed"] = 172] = "TransportSessionClosed";
    MongoDB[MongoDB["TransportSessionNotFound"] = 173] = "TransportSessionNotFound";
    MongoDB[MongoDB["TransportSessionUnknown"] = 174] = "TransportSessionUnknown";
    MongoDB[MongoDB["QueryPlanKilled"] = 175] = "QueryPlanKilled";
    MongoDB[MongoDB["FileOpenFailed"] = 176] = "FileOpenFailed";
    MongoDB[MongoDB["ZoneNotFound"] = 177] = "ZoneNotFound";
    MongoDB[MongoDB["RangeOverlapConflict"] = 178] = "RangeOverlapConflict";
    MongoDB[MongoDB["WindowsPdhError"] = 179] = "WindowsPdhError";
    MongoDB[MongoDB["BadPerfCounterPath"] = 180] = "BadPerfCounterPath";
    MongoDB[MongoDB["AmbiguousIndexKeyPattern"] = 181] = "AmbiguousIndexKeyPattern";
    MongoDB[MongoDB["InvalidViewDefinition"] = 182] = "InvalidViewDefinition";
    MongoDB[MongoDB["ClientMetadataMissingField"] = 183] = "ClientMetadataMissingField";
    MongoDB[MongoDB["ClientMetadataAppNameTooLarge"] = 184] = "ClientMetadataAppNameTooLarge";
    MongoDB[MongoDB["ClientMetadataDocumentTooLarge"] = 185] = "ClientMetadataDocumentTooLarge";
    MongoDB[MongoDB["ClientMetadataCannotBeMutated"] = 186] = "ClientMetadataCannotBeMutated";
    MongoDB[MongoDB["LinearizableReadConcernError"] = 187] = "LinearizableReadConcernError";
    MongoDB[MongoDB["IncompatibleServerVersion"] = 188] = "IncompatibleServerVersion";
    MongoDB[MongoDB["PrimarySteppedDown"] = 189] = "PrimarySteppedDown";
    MongoDB[MongoDB["MasterSlaveConnectionFailure"] = 190] = "MasterSlaveConnectionFailure";
    MongoDB[MongoDB["OBSOLETE_BalancerLostDistributedLock"] = 191] = "OBSOLETE_BalancerLostDistributedLock";
    MongoDB[MongoDB["FailPointEnabled"] = 192] = "FailPointEnabled";
    MongoDB[MongoDB["NoShardingEnabled"] = 193] = "NoShardingEnabled";
    MongoDB[MongoDB["BalancerInterrupted"] = 194] = "BalancerInterrupted";
    MongoDB[MongoDB["ViewPipelineMaxSizeExceeded"] = 195] = "ViewPipelineMaxSizeExceeded";
    MongoDB[MongoDB["InvalidIndexSpecificationOption"] = 197] = "InvalidIndexSpecificationOption";
    MongoDB[MongoDB["OBSOLETE_ReceivedOpReplyMessage"] = 198] = "OBSOLETE_ReceivedOpReplyMessage";
    MongoDB[MongoDB["ReplicaSetMonitorRemoved"] = 199] = "ReplicaSetMonitorRemoved";
    MongoDB[MongoDB["ChunkRangeCleanupPending"] = 200] = "ChunkRangeCleanupPending";
    MongoDB[MongoDB["CannotBuildIndexKeys"] = 201] = "CannotBuildIndexKeys";
    MongoDB[MongoDB["NetworkInterfaceExceededTimeLimit"] = 202] = "NetworkInterfaceExceededTimeLimit";
    MongoDB[MongoDB["ShardingStateNotInitialized"] = 203] = "ShardingStateNotInitialized";
    MongoDB[MongoDB["TimeProofMismatch"] = 204] = "TimeProofMismatch";
    MongoDB[MongoDB["ClusterTimeFailsRateLimiter"] = 205] = "ClusterTimeFailsRateLimiter";
    MongoDB[MongoDB["NoSuchSession"] = 206] = "NoSuchSession";
    MongoDB[MongoDB["InvalidUUID"] = 207] = "InvalidUUID";
    MongoDB[MongoDB["TooManyLocks"] = 208] = "TooManyLocks";
    MongoDB[MongoDB["StaleClusterTime"] = 209] = "StaleClusterTime";
    MongoDB[MongoDB["CannotVerifyAndSignLogicalTime"] = 210] = "CannotVerifyAndSignLogicalTime";
    MongoDB[MongoDB["KeyNotFound"] = 211] = "KeyNotFound";
    MongoDB[MongoDB["IncompatibleRollbackAlgorithm"] = 212] = "IncompatibleRollbackAlgorithm";
    MongoDB[MongoDB["DuplicateSession"] = 213] = "DuplicateSession";
    MongoDB[MongoDB["AuthenticationRestrictionUnmet"] = 214] = "AuthenticationRestrictionUnmet";
    MongoDB[MongoDB["DatabaseDropPending"] = 215] = "DatabaseDropPending";
    MongoDB[MongoDB["ElectionInProgress"] = 216] = "ElectionInProgress";
    MongoDB[MongoDB["IncompleteTransactionHistory"] = 217] = "IncompleteTransactionHistory";
    MongoDB[MongoDB["UpdateOperationFailed"] = 218] = "UpdateOperationFailed";
    MongoDB[MongoDB["FTDCPathNotSet"] = 219] = "FTDCPathNotSet";
    MongoDB[MongoDB["FTDCPathAlreadySet"] = 220] = "FTDCPathAlreadySet";
    MongoDB[MongoDB["IndexModified"] = 221] = "IndexModified";
    MongoDB[MongoDB["CloseChangeStream"] = 222] = "CloseChangeStream";
    MongoDB[MongoDB["IllegalOpMsgFlag"] = 223] = "IllegalOpMsgFlag";
    MongoDB[MongoDB["QueryFeatureNotAllowed"] = 224] = "QueryFeatureNotAllowed";
    MongoDB[MongoDB["TransactionTooOld"] = 225] = "TransactionTooOld";
    MongoDB[MongoDB["AtomicityFailure"] = 226] = "AtomicityFailure";
    MongoDB[MongoDB["CannotImplicitlyCreateCollection"] = 227] = "CannotImplicitlyCreateCollection";
    MongoDB[MongoDB["SessionTransferIncomplete"] = 228] = "SessionTransferIncomplete";
    MongoDB[MongoDB["MustDowngrade"] = 229] = "MustDowngrade";
    MongoDB[MongoDB["DNSHostNotFound"] = 230] = "DNSHostNotFound";
    MongoDB[MongoDB["DNSProtocolError"] = 231] = "DNSProtocolError";
    MongoDB[MongoDB["MaxSubPipelineDepthExceeded"] = 232] = "MaxSubPipelineDepthExceeded";
    MongoDB[MongoDB["TooManyDocumentSequences"] = 233] = "TooManyDocumentSequences";
    MongoDB[MongoDB["RetryChangeStream"] = 234] = "RetryChangeStream";
    MongoDB[MongoDB["InternalErrorNotSupported"] = 235] = "InternalErrorNotSupported";
    MongoDB[MongoDB["ForTestingErrorExtraInfo"] = 236] = "ForTestingErrorExtraInfo";
    MongoDB[MongoDB["CursorKilled"] = 237] = "CursorKilled";
    MongoDB[MongoDB["NotImplemented"] = 238] = "NotImplemented";
    MongoDB[MongoDB["SnapshotTooOld"] = 239] = "SnapshotTooOld";
    MongoDB[MongoDB["DNSRecordTypeMismatch"] = 240] = "DNSRecordTypeMismatch";
    MongoDB[MongoDB["ConversionFailure"] = 241] = "ConversionFailure";
    MongoDB[MongoDB["CannotCreateCollection"] = 242] = "CannotCreateCollection";
    MongoDB[MongoDB["IncompatibleWithUpgradedServer"] = 243] = "IncompatibleWithUpgradedServer";
    MongoDB[MongoDB["NOT_YET_AVAILABLE_TransactionAborted"] = 244] = "NOT_YET_AVAILABLE_TransactionAborted";
    MongoDB[MongoDB["BrokenPromise"] = 245] = "BrokenPromise";
    MongoDB[MongoDB["SnapshotUnavailable"] = 246] = "SnapshotUnavailable";
    MongoDB[MongoDB["ProducerConsumerQueueBatchTooLarge"] = 247] = "ProducerConsumerQueueBatchTooLarge";
    MongoDB[MongoDB["ProducerConsumerQueueEndClosed"] = 248] = "ProducerConsumerQueueEndClosed";
    MongoDB[MongoDB["StaleDbVersion"] = 249] = "StaleDbVersion";
    MongoDB[MongoDB["StaleChunkHistory"] = 250] = "StaleChunkHistory";
    MongoDB[MongoDB["NoSuchTransaction"] = 251] = "NoSuchTransaction";
    MongoDB[MongoDB["ReentrancyNotAllowed"] = 252] = "ReentrancyNotAllowed";
    MongoDB[MongoDB["FreeMonHttpInFlight"] = 253] = "FreeMonHttpInFlight";
    MongoDB[MongoDB["FreeMonHttpTemporaryFailure"] = 254] = "FreeMonHttpTemporaryFailure";
    MongoDB[MongoDB["FreeMonHttpPermanentFailure"] = 255] = "FreeMonHttpPermanentFailure";
    MongoDB[MongoDB["TransactionCommitted"] = 256] = "TransactionCommitted";
    MongoDB[MongoDB["TransactionTooLarge"] = 257] = "TransactionTooLarge";
    MongoDB[MongoDB["UnknownFeatureCompatibilityVersion"] = 258] = "UnknownFeatureCompatibilityVersion";
    MongoDB[MongoDB["KeyedExecutorRetry"] = 259] = "KeyedExecutorRetry";
    MongoDB[MongoDB["InvalidResumeToken"] = 260] = "InvalidResumeToken";
    MongoDB[MongoDB["TooManyLogicalSessions"] = 261] = "TooManyLogicalSessions";
    MongoDB[MongoDB["ExceededTimeLimit"] = 262] = "ExceededTimeLimit";
    MongoDB[MongoDB["OperationNotSupportedInTransaction"] = 263] = "OperationNotSupportedInTransaction";
    MongoDB[MongoDB["TooManyFilesOpen"] = 264] = "TooManyFilesOpen";
    MongoDB[MongoDB["OrphanedRangeCleanUpFailed"] = 265] = "OrphanedRangeCleanUpFailed";
    MongoDB[MongoDB["FailPointSetFailed"] = 266] = "FailPointSetFailed";
    MongoDB[MongoDB["PreparedTransactionInProgress"] = 267] = "PreparedTransactionInProgress";
    MongoDB[MongoDB["CannotBackup"] = 268] = "CannotBackup";
    MongoDB[MongoDB["DataModifiedByRepair"] = 269] = "DataModifiedByRepair";
    MongoDB[MongoDB["RepairedReplicaSetNode"] = 270] = "RepairedReplicaSetNode";
    MongoDB[MongoDB["JSInterpreterFailureWithStack"] = 271] = "JSInterpreterFailureWithStack";
    MongoDB[MongoDB["MigrationConflict"] = 272] = "MigrationConflict";
    MongoDB[MongoDB["ProducerConsumerQueueProducerQueueDepthExceeded"] = 273] = "ProducerConsumerQueueProducerQueueDepthExceeded";
    MongoDB[MongoDB["ProducerConsumerQueueConsumed"] = 274] = "ProducerConsumerQueueConsumed";
    MongoDB[MongoDB["ExchangePassthrough"] = 275] = "ExchangePassthrough";
    MongoDB[MongoDB["IndexBuildAborted"] = 276] = "IndexBuildAborted";
    MongoDB[MongoDB["AlarmAlreadyFulfilled"] = 277] = "AlarmAlreadyFulfilled";
    MongoDB[MongoDB["UnsatisfiableCommitQuorum"] = 278] = "UnsatisfiableCommitQuorum";
    MongoDB[MongoDB["ClientDisconnect"] = 279] = "ClientDisconnect";
    MongoDB[MongoDB["ChangeStreamFatalError"] = 280] = "ChangeStreamFatalError";
    MongoDB[MongoDB["TransactionCoordinatorSteppingDown"] = 281] = "TransactionCoordinatorSteppingDown";
    MongoDB[MongoDB["TransactionCoordinatorReachedAbortDecision"] = 282] = "TransactionCoordinatorReachedAbortDecision";
    MongoDB[MongoDB["WouldChangeOwningShard"] = 283] = "WouldChangeOwningShard";
    MongoDB[MongoDB["ForTestingErrorExtraInfoWithExtraInfoInNamespace"] = 284] = "ForTestingErrorExtraInfoWithExtraInfoInNamespace";
    MongoDB[MongoDB["IndexBuildAlreadyInProgress"] = 285] = "IndexBuildAlreadyInProgress";
    MongoDB[MongoDB["ChangeStreamHistoryLost"] = 286] = "ChangeStreamHistoryLost";
    MongoDB[MongoDB["TransactionCoordinatorDeadlineTaskCanceled"] = 287] = "TransactionCoordinatorDeadlineTaskCanceled";
    MongoDB[MongoDB["ChecksumMismatch"] = 288] = "ChecksumMismatch";
    MongoDB[MongoDB["WaitForMajorityServiceEarlierOpTimeAvailable"] = 289] = "WaitForMajorityServiceEarlierOpTimeAvailable";
    MongoDB[MongoDB["TransactionExceededLifetimeLimitSeconds"] = 290] = "TransactionExceededLifetimeLimitSeconds";
    MongoDB[MongoDB["NoQueryExecutionPlans"] = 291] = "NoQueryExecutionPlans";
    MongoDB[MongoDB["QueryExceededMemoryLimitNoDiskUseAllowed"] = 292] = "QueryExceededMemoryLimitNoDiskUseAllowed";
    MongoDB[MongoDB["InvalidSeedList"] = 293] = "InvalidSeedList";
    MongoDB[MongoDB["InvalidTopologyType"] = 294] = "InvalidTopologyType";
    MongoDB[MongoDB["InvalidHeartBeatFrequency"] = 295] = "InvalidHeartBeatFrequency";
    MongoDB[MongoDB["TopologySetNameRequired"] = 296] = "TopologySetNameRequired";
    MongoDB[MongoDB["HierarchicalAcquisitionLevelViolation"] = 297] = "HierarchicalAcquisitionLevelViolation";
    MongoDB[MongoDB["InvalidServerType"] = 298] = "InvalidServerType";
    MongoDB[MongoDB["OCSPCertificateStatusRevoked"] = 299] = "OCSPCertificateStatusRevoked";
    MongoDB[MongoDB["RangeDeletionAbandonedBecauseCollectionWithUUIDDoesNotExist"] = 300] = "RangeDeletionAbandonedBecauseCollectionWithUUIDDoesNotExist";
    MongoDB[MongoDB["DataCorruptionDetected"] = 301] = "DataCorruptionDetected";
    MongoDB[MongoDB["OCSPCertificateStatusUnknown"] = 302] = "OCSPCertificateStatusUnknown";
    MongoDB[MongoDB["SplitHorizonChange"] = 303] = "SplitHorizonChange";
    MongoDB[MongoDB["ShardInvalidatedForTargeting"] = 304] = "ShardInvalidatedForTargeting";
    MongoDB[MongoDB["ReadThroughCacheKeyNotFound"] = 305] = "ReadThroughCacheKeyNotFound";
    MongoDB[MongoDB["ReadThroughCacheLookupCanceled"] = 306] = "ReadThroughCacheLookupCanceled";
    MongoDB[MongoDB["RangeDeletionAbandonedBecauseTaskDocumentDoesNotExist"] = 307] = "RangeDeletionAbandonedBecauseTaskDocumentDoesNotExist";
    MongoDB[MongoDB["SocketException"] = 9001] = "SocketException";
    MongoDB[MongoDB["OBSOLETE_RecvStaleConfig"] = 9996] = "OBSOLETE_RecvStaleConfig";
    MongoDB[MongoDB["CannotGrowDocumentInCappedNamespace"] = 10003] = "CannotGrowDocumentInCappedNamespace";
    MongoDB[MongoDB["NotMaster"] = 10107] = "NotMaster";
    MongoDB[MongoDB["BSONObjectTooLarge"] = 10334] = "BSONObjectTooLarge";
    MongoDB[MongoDB["DuplicateKey"] = 11000] = "DuplicateKey";
    MongoDB[MongoDB["InterruptedAtShutdown"] = 11600] = "InterruptedAtShutdown";
    MongoDB[MongoDB["Interrupted"] = 11601] = "Interrupted";
    MongoDB[MongoDB["InterruptedDueToReplStateChange"] = 11602] = "InterruptedDueToReplStateChange";
    MongoDB[MongoDB["BackgroundOperationInProgressForDatabase"] = 12586] = "BackgroundOperationInProgressForDatabase";
    MongoDB[MongoDB["BackgroundOperationInProgressForNamespace"] = 12587] = "BackgroundOperationInProgressForNamespace";
    MongoDB[MongoDB["OBSOLETE_PrepareConfigsFailed"] = 13104] = "OBSOLETE_PrepareConfigsFailed";
    MongoDB[MongoDB["MergeStageNoMatchingDocument"] = 13113] = "MergeStageNoMatchingDocument";
    MongoDB[MongoDB["DatabaseDifferCase"] = 13297] = "DatabaseDifferCase";
    MongoDB[MongoDB["StaleConfig"] = 13388] = "StaleConfig";
    MongoDB[MongoDB["NotMasterNoSlaveOk"] = 13435] = "NotMasterNoSlaveOk";
    MongoDB[MongoDB["NotMasterOrSecondary"] = 13436] = "NotMasterOrSecondary";
    MongoDB[MongoDB["OutOfDiskSpace"] = 14031] = "OutOfDiskSpace";
    MongoDB[MongoDB["OBSOLETE_KeyTooLong"] = 17280] = "OBSOLETE_KeyTooLong";
})(MongoDB = exports.MongoDB || (exports.MongoDB = {}));
//# sourceMappingURL=mongodb.js.map